/*@flow*/
import titleize from 'underscore.string/titleize';

function utilCollectErrors(e: { errors: { [key: string]: string[] } }): Array<any | string> {
  let errs = [];
  Object.keys(e.errors).forEach(k => {
    e.errors[k].forEach(v => {
      errs.push(`${titleize(k)} ${v}`);
    });
  });
  return errs;
}

export default utilCollectErrors;
